import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import {
    CK_AUTH_CONFIG,
    CKAesCryptoHelper,
    CKAuthGuard,
    CKAuthModule,
    CKAuthService,
    CKGuestGuard,
    HttpHelper,
} from '@ck-core/ck-auth';
import { ENVIRONMENT } from '@ck-core/ck-controls';
import { MSAL_INSTANCE, MsalModule, MsalService } from '@azure/msal-angular';
import {
    InteractionType,
    IPublicClientApplication,
    PublicClientApplication,
} from '@azure/msal-browser';

import { environment } from '../../../environments/environment';

function msalInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: environment.microsoftClientId || '00000000-0000-0000-0000-000000000000',
            authority: 'https://login.microsoftonline.com/common',
            redirectUri: environment.applicationUrl,
        },
        cache: {
            cacheLocation: 'localStorage',
        },
    });
}

export function provideCkHttp(): EnvironmentProviders {
    return makeEnvironmentProviders([
        importProvidersFrom(
            CKAuthModule,
            MsalModule.forRoot(
                msalInstanceFactory(),
                { interactionType: InteractionType.Redirect },
                {
                    interactionType: InteractionType.Redirect,
                    protectedResourceMap: new Map(),
                },
            ),
        ),
        { provide: CK_AUTH_CONFIG, useValue: environment },
        { provide: ENVIRONMENT, useValue: environment },
        { provide: MSAL_INSTANCE, useFactory: msalInstanceFactory },
        CKAesCryptoHelper,
        CKAuthService,
        HttpHelper,
        CKAuthGuard,
        CKGuestGuard,
        MsalService,
    ]);
}
